import type { FC } from 'react';
import { Tab, Tabs } from '@cencosud-cencommerce/paris-uikit';

import type { SendGtmEvent } from '@/modules/shared/utils/gtmEvents/buyNowTypes';
import {
  BuyNowEventInteractiveCategories,
  BuyNowEventInteractiveTags
} from '@/modules/shared/utils/gtmEvents/buyNowTypes';
import { sendEvent } from '@/modules/shared/utils/gtmEvents/sendEvents/sendBuyNowEvents';
import {
  TAB_PICKUP,
  TAB_SHIPPING
} from '@/Pages/BuyNowPage/PaymentAndShipping/constants';
import type { ShippingTabNavigationProps } from '@/Pages/BuyNowPage/PaymentAndShipping/interfaces';

const LABEL_PICKUP_NOT_AVAILABLE = 'Retiro no disponible';
const LABEL_PICKUP = 'Retiro';
const LABEL_FREE = 'Gratis';
const LABEL_DELIVERY_NOT_AVAILABLE = 'Despacho no disponible';
const LABEL_DELIVERY = 'Despacho';

const EVENT_DELIVERY: SendGtmEvent = {
  event: 'baseEvent',
  extraFields: {
    'event-interactive-tag': BuyNowEventInteractiveTags.Despacho,
    'event-interactive-category': BuyNowEventInteractiveCategories.FastCheckout
  }
};

const EVENT_COLLECT: SendGtmEvent = {
  event: 'baseEvent',
  extraFields: {
    'event-interactive-tag': BuyNowEventInteractiveTags.Retiro,
    'event-interactive-category': BuyNowEventInteractiveCategories.FastCheckout
  }
};

export const ShippingTabNavigation: FC<ShippingTabNavigationProps> = ({
  group,
  setTabActive,
  tabActive
}) => {
  if (!group) return null;

  const hasPickupOptions = group?.pickupOptions?.length ?? 0 > 0;

  const hasShippingOptions = group?.shippingOptions?.length ?? 0 > 0;
  const hasSchedulableOptions = group?.scheduledOptions?.length ?? 0 > 0;
  const hasDeliveryOptions = hasShippingOptions || hasSchedulableOptions;

  const hasFreePickup = group?.pickupOptions?.some((option) => option.isFree);

  const deliveryDisabled = !hasDeliveryOptions;
  const pickupDisabled = !hasPickupOptions;

  const deliveryTabLabel = deliveryDisabled
    ? LABEL_DELIVERY_NOT_AVAILABLE
    : LABEL_DELIVERY;

  const pickupTabLabel = pickupDisabled
    ? LABEL_PICKUP_NOT_AVAILABLE
    : LABEL_PICKUP;

  const pickupTagProps = hasFreePickup
    ? {
        children: LABEL_FREE
      }
    : undefined;

  const handleDeliveryTabClick = () => {
    if (tabActive === TAB_SHIPPING) return;
    setTabActive(TAB_SHIPPING);
    sendEvent(EVENT_DELIVERY);
  };

  const handlePickupTabClick = () => {
    if (tabActive === TAB_PICKUP) return;
    setTabActive(TAB_PICKUP);
    sendEvent(EVENT_COLLECT);
  };

  return (
    <nav className="co-flex co-items-center co-p-3 co-border-t co-border-t-neutral-300 tablet:co-border-0 tablet:co-p-0">
      <Tabs className="co-w-full tablet_w:co-w-auto">
        <Tab
          active={tabActive === TAB_PICKUP}
          iconName="il-store"
          label={pickupTabLabel}
          name={TAB_PICKUP}
          disabled={pickupDisabled}
          onClick={handlePickupTabClick}
          tagProps={pickupTagProps}
        />

        <Tab
          active={tabActive === TAB_SHIPPING}
          iconName="il-delivery"
          label={deliveryTabLabel}
          name={TAB_SHIPPING}
          disabled={deliveryDisabled}
          onClick={handleDeliveryTabClick}
        />
      </Tabs>
    </nav>
  );
};

export default ShippingTabNavigation;
